
    import './styles.scoped.css';
    export default {
  "series": "awsui_series_1yz9c_2aodi_93",
  "series--bar": "awsui_series--bar_1yz9c_2aodi_94",
  "series__rect": "awsui_series__rect_1yz9c_2aodi_94",
  "exiting": "awsui_exiting_1yz9c_2aodi_111",
  "awsui-motion-fade-out-0": "awsui_awsui-motion-fade-out-0_1yz9c_2aodi_1",
  "root": "awsui_root_1yz9c_2aodi_137",
  "filter-container": "awsui_filter-container_1yz9c_2aodi_150",
  "has-default-filter": "awsui_has-default-filter_1yz9c_2aodi_154",
  "chart-container": "awsui_chart-container_1yz9c_2aodi_158",
  "chart-container__vertical": "awsui_chart-container__vertical_1yz9c_2aodi_164",
  "chart-container__horizontal": "awsui_chart-container__horizontal_1yz9c_2aodi_170",
  "content": "awsui_content_1yz9c_2aodi_174",
  "content--reserve-filter": "awsui_content--reserve-filter_1yz9c_2aodi_181",
  "content--reserve-legend": "awsui_content--reserve-legend_1yz9c_2aodi_185",
  "series--highlighted": "awsui_series--highlighted_1yz9c_2aodi_198",
  "series__bar--highlighted": "awsui_series__bar--highlighted_1yz9c_2aodi_199",
  "series--dimmed": "awsui_series--dimmed_1yz9c_2aodi_203",
  "series--threshold": "awsui_series--threshold_1yz9c_2aodi_212",
  "bar-group": "awsui_bar-group_1yz9c_2aodi_217"
};
  